import { createMachine } from "@indietabletop/appkit";
import { client } from "../client";
import { database } from "../database/database";

export const machine = createMachine({
  database,
  client,
  pullGameDataFor: ["greathelm"],
});
